module.exports = __webpack_public_path__ + "img/recruit1.f92a44e1.png";